/* eslint-disable */
import React, { FC, useState, useContext, useEffect } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import { useHistory } from 'react-router-dom';
import { LoginContext } from '../context/LoginContext';
import {LanguageContext} from '../context/localization/languageState'
import Label from '../atoms/label/label';
import {
  resendOtp,
  verifyLoginOtp,
} from '../dataLayer/webauthData';
import LoaderLight from '../atoms/loaderLight/loaderLight';
import loaderData from '../assets/loader.json';
import greyDot from '../assets/fieldIcons/greyDot.png';
import './otp.scss';
import 'react-responsive-modal/styles.css';

import BackArrow from '../atoms/backArrow/backArrow';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { setDeviceId } from '../PhoneNumber';

var CryptoJS = require('crypto-js');

const OTP = ({
  open,
  otpError,
  onClose,
  onBack,
  signInSuccess,
  signUpSuccess,
  triggerNewUser,
}) => {
  const history = useHistory();
  const [phoneOTP, setPhoneOTP] = useState({ otp: '1234' });
  const [phoneOTPHidden, setPhoneOTPHidden] = useState({ otp: '' });
  const [greyDotArr, setGreyDotArr] = useState([true, true, true, true]);
  const [otpValidation, setOTPValidation] = useState(false);
  const [resendBtnEnabled, setResendBtnEnabled] = useState(false);
  const [otpModalText, setOtpModalText] = useState('');
  const [otpTimer, setOtpTimer] = useState(120);
  const [otpTimerString, setOtpTimerString] = useState('2:00');
  const [otpNumberClass, setOtpNumberClass] = useState('otp-number-normal');
  const [showToast, setShowToast] = useState('none');
  const [toastMessage, setToastMessage] = useState('');
  const [otpResendAttempts, setOtpResendAttempts] = useState(1);
  const [iOSbtnNormal, setIOSbtnNormal] = useState('');
  const [iOSbtnEnabled, setIOSbtnEnabled] = useState('');
  let interval;
  let timeLeft;
  const [loader, setLoader] = useState(false);
  const loginContext = useContext(LoginContext);
  const [generalData, setGeneralData] = useState('');
  const { search } = useLocation();
  const queryParamValues = queryString.parse(search);
  const [flagstt, setFlagStt] = useState(false);
  const currentLocation = history.location.pathname;
  const localization = useContext(LanguageContext)
  const {
    otp_text,
    generic_api_error_toast_message,
    helloText,
    nextText,
    enterOTPSentToText,
    resendText,
    didntGetOTPText,
    otpHasBeenSentToastMessage,
    invalidOTPToastMessage,
    somethingWentWrongToastMessage,
    resendOTPLimitExceeded,
    resendOTPSessionExpired,
    enterOTPText,
  } = localization.state.language;
  useEffect(() => {
    if (flagstt) {
      console.log('Flag status is true');
    }
  }, [flagstt]);

  function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  useEffect(() => {
    if (getCookie('oem_auth_token')) {
      axios
        .get('/api/auth/validateAuth', {
          headers: {
            oem_auth_token: getCookie('oem_auth_token'),
          },
        })
        .then((res) => {
          console.log('The validation status is ', res);
          history.push('/booking-list');
        })
        .catch((err) => {
          history.push('/phoneNumber');
          console.log('The error is ', err);
        });
      // history.push('/selectSavedCards');
    } else {
      let generaldata = JSON.parse(localStorage.getItem('generalData'));
      setGeneralData(generaldata);
      document.addEventListener('click', function () {}, false);
      setLoader(false);

      setOtpModalText(
        loginContext.state.accountDetails.newUser === false &&
          loginContext.state.accountDetails.fullName !== ''
          ? helloText +
              loginContext.state.accountDetails.fullName +
              '! ' +
              enterOTPText
          : enterOTPSentToText,
      );
    }
  }, []);

  useEffect(() => {
    if (otpError) setOtpNumberClass('otp-number-error');
    else reset();
  }, [otpError]);

  const reset = () => {
    setPhoneOTP({ otp: '' });
    setPhoneOTPHidden({ otp: '' });
    setOTPValidation(false);
    setOtpNumberClass('otp-number-normal');
    resetInterval();
  };

  const otpHandler = (value) => {
    // console.log('The value is ))', value);
    // console.log('Hidden field ', phoneOTPHidden.otp);
    // console.log(String(value).slice(-1));
    // let otp = phoneOTP.otp + String(value).slice(-1);
    setPhoneOTP({ otp: value });
    // console.log('The flag status is ', flagstt);
    // setPhoneOTP({ otp: otp });
    switch (value.length) {
      case 0:
        setGreyDotArr([true, true, true, true]);
        setPhoneOTPHidden({ otp: '' });

        break;
      case 1:
        setGreyDotArr([false, true, true, true]);
        setPhoneOTPHidden({ otp: '*' });

        break;
      case 2:
        setGreyDotArr([false, false, true, true]);
        setPhoneOTPHidden({ otp: '**' });

        break;
      case 3:
        setGreyDotArr([false, false, false, true]);
        setPhoneOTPHidden({ otp: '***' });

        break;
      case 4:
        setGreyDotArr([false, false, false, false]);
        setPhoneOTPHidden({ otp: '****' });

        break;

      default:
        setGreyDotArr([true, true, true, true]);
        setPhoneOTPHidden({ otp: '' });

        break;
    }

    if (value.length === 4) {
      setOtpNumberClass('otp-number');
      setOTPValidation(true);
    } else if (value.length === 0) {
      setOTPValidation(false);
      setOtpNumberClass('otp-number');
    } else {
      setOTPValidation(false);
      setOtpNumberClass('otp-number');
    }
  };

  const onResendOtp = () => {
    setPhoneOTP({ otp: '' });
    setPhoneOTPHidden({ otp: '' });
    // The call to setDeviceId() should have ideally set the `device_id`
    // If it fails, we'll try to put these calls in the success callback.
    let fingerPrint = localStorage.getItem('device_id');
    // default value initialization for cases
    // if the user opens `/otp` page directly
    // without visiting the `/phoneNumber` page
    let isCaptchaRequired = localStorage.getItem('isCaptchaRequired') || true;
    let captchaInfo = {
      fingerPrint,
      storageId: localStorage.getItem('storageId'),
    };

    if (isCaptchaRequired) {
      captchaInfo['gcaptcha'] = localStorage.getItem('tokenC');
    }

    let data = {
      mobileNumber: generalData.phoneNumber,
      name: localStorage.getItem('nm'),
      email: localStorage.getItem('em'),
      dialingCode: loginContext.state.selectedCountry.dialingCode,
      countryCode: loginContext.state.selectedCountry.countryCode,
      verificationId: loginContext.state.accountDetails.verificationId,
      newUser: loginContext.state.accountDetails.newUser,
      captchaInfo,
    };
    resendOtp(data).then(
      (res) => {
        if (
          res.data &&
          res.data.status &&
          res.data.status.toString().toLowerCase() === 'success'
        ) {
          setOtpNumberClass('otp-number-normal');
          setToastMessage(otpHasBeenSentToastMessage);
          setShowToast('block');
          setTimeout(() => {
            setShowToast('none');
          }, 2000);
          resetInterval();

        } else if (
          res.data &&
          res.data.status &&
          res.data.status.toString().toLowerCase() === 'failure' &&
          res.data.message.indexOf('limit') > 0
        ) {
          setToastMessage(resendOTPLimitExceeded);
          setShowToast('block');
          setTimeout(() => {
            setShowToast('none');
            history.push('/phoneNumber');
          }, 2000);
        } else if (
          res.data &&
          res.data.status &&
          res.data.status.toString().toLowerCase() === 'failure' &&
          res.data.message.indexOf('expired') > 0
        ) {
          setToastMessage(resendOTPSessionExpired);
          setShowToast('block');
          setTimeout(() => {
            setShowToast('none');
            history.push('/phoneNumber');
          }, 2000);
        } else {
          // Take the user back to main login screen to verify captcha
          setToastMessage(somethingWentWrongToastMessage);
          setShowToast('block');
          setTimeout(() => {
            setShowToast('none');
          }, 1000);
          history.push('/phoneNumber');
        }
      },
      (err) => {
        setLoader(false);
        setToastMessage(generic_api_error_toast_message);
        setShowToast('block');
        setTimeout(() => {
          setShowToast('none');
        }, 1000);

        let tempErrMessage = err.status;
      },
    );
    setOtpResendAttempts(otpResendAttempts + 1);
  };

  const loginForExistingUser = () => {
    console.log('phoneOTP.otp ::: ', phoneOTP.otp);
    let fingerPrint = localStorage.getItem('device_id');
    localStorage.setItem('device_id', fingerPrint); // just-in-case there is no device ID

    let data = {
      otp: CryptoJS.AES.encrypt(phoneOTP.otp, '123456789').toString(),
      newUser: false,
      name: '',
      email: '',
      mobileNumber: generalData.phoneNumber,
      dialingCode: loginContext.state.selectedCountry.dialingCode,
      countryCode: loginContext.state.selectedCountry.countryCode,
      verificationId: loginContext.state.accountDetails.verificationId,
      captchaInfo: {
        gcaptcha: localStorage.getItem('tokenC'),
        fingerPrint,
        storageId: localStorage.getItem('storageId'),
      },
    };
    verifyLoginOtp(data)
      .then((res) => {
        // console.log('verifyLoginOtp : ', res);
        const newUser = loginContext.state.accountDetails.newUser;
        // console.log('newUser status ',newUser)
        if (newUser) {
          history.push('/account');
        } else {
          setLoader(false);
          let token_through_web = getCookie('oem_auth_token');
          //notify start

          //notify end
          if (
            res.data &&
            res.data.status &&
            res.data.status.toString().toLowerCase() === 'success'
          ) {
            let temp_uuid = getCookie('utm_uuid');

            // console.log("Mfa required : ",res.data.mfaRequired);
            if (res.data.mfaRequired) {
              localStorage.setItem('ssoflow', 'password');
              localStorage.setItem('flow', 'login');
              let accountDetails = {
                ...loginContext.state.accountDetails,
                mfaInfo: res.data.mfaInfo || null,
                ivrInfo: res.data.ivrInfo || null,
                passwordInfo: res.data.passwordInfo || null,
                showLink: res.data.showLink || false,
              };
              loginContext.dispatch.setAccountDetails(accountDetails);
              console.log("history",res.data)
              history.push('/password')
            } else {
              handleUserAuthentication(res);
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
        setToastMessage(somethingWentWrongToastMessage);
        setShowToast('block');
        setTimeout(() => {
          setShowToast('none');
          history.push('/phoneNumber');
        }, 6000);

      });
  };

  const handleUserAuthentication = async (res) => {
    const redirectUrl = sessionStorage.getItem("postLoginRedirect");

if (redirectUrl?.startsWith("/manage-orders")) {
  sessionStorage.removeItem("postLoginRedirect");
  history.push(redirectUrl);
} else {
   history.push('/booking-list')
}
    // console.log('Inside handleUserAuthentication')


   // await user.dispatch.asyncSetUserDetails();


    // setOtpNumberClass('otp-number');
    // if (res.data.oem_user_created === 'SIGN_UP') {
    //   // globalData.dispatch.setOemUser(true);
    //   if (localStorage) {
    //     localStorage.setItem('iNU', true);
    //   }
    //   //openGetUpdatesModal();
    //   history.push('/selectVariant');
    // } 
  };

  useEffect(() => {
    (async () => {
      await setDeviceId();
    })();
    return history.listen((location) => {
      // console.log("USING LOCATION");
      // console.log("LOCATION IS --",location);
      // console.log("CURRENTLOCATION IS",currentLocation);
    });
  }, [history]);

  const resetInterval = () => {
    setResendBtnEnabled(false);
    if (interval) {
      clearInterval(interval);
    }
    timeLeft = 15;
    interval = setInterval(() => {
      timeLeft--;
      if (timeLeft === 0) {
        setResendBtnEnabled(true);
        clearInterval(interval);
      }
    }, 1000);
  };

  const otpNextButtonClick = (evt) => {
    //clear all cookie
     document.cookie="oem_auth_token=";
     document.cookie="oem_refresh_token=";
    //end
    evt.preventDefault();
    setLoader(true);
    let accountDetails = {
      ...loginContext.state.accountDetails,
      otp: phoneOTP.otp,
    };
    // console.log('The accountDetails ~~~~ ', accountDetails);
    const newUser = loginContext.state.accountDetails.newUser;
    loginContext.dispatch.setAccountDetails(accountDetails);

    if (newUser) {
        setLoader(false);
        setToastMessage("You are unauthorized!");
        setShowToast('block');
        setTimeout(() => {
          setShowToast('none');
          history.push('/phoneNumber');
        }, 3000);
    } else loginForExistingUser();
  };

  const otpFocus = () => {
    setOtpNumberClass('otp-number');
    setIOSbtnNormal('nextBtn-np-ios-otp');
    setIOSbtnEnabled('nextBtn-np-ios-otp');
  };
  const otpBlur = () => {
    setOtpNumberClass('otp-number-normal');
    setIOSbtnNormal('');
    setIOSbtnEnabled('');
  };

  return (
    <>
      {/* <Modal
        open={open}
        onClose={onClose}
        isShowNextBtn={!loader}
        isValidBtn={otpValidation}
        onClick={otpValidation ? onClick : () => {}}
        onBackClick={onBack}
        modalId="otpModal"
      > */}
      <div className="new-purchase-main-container nextButtonwidth">
        <div className="right-container">
          <Link to="/phoneNumber">
            <BackArrow />
          </Link>
          <div className="vertical-center-otp">
            <div className="otp-field-section">
              <div className="otp-top-texts">
                <Label className="otp-text" text={otpModalText} />
                {/* {generalData && (
                  <Label
                    className="otp-text-2"
                    text={otpModalText.split('to')[1]}
                    // text={`${generalData.phoneNumber}`}
                  />
                )} */}
                {generalData && (
                  <Label
                    className="otp-text-2"
                    text={`${generalData.dialingCode}*******${String(
                      generalData.phoneNumber,
                    ).substr(-3)}`}
                  />
                )}

                <div className="otp-subtext">
                  <span>{didntGetOTPText}</span>
                  <span onClick={onResendOtp} className="enabled-btn">
                    {' ' + resendText}
                  </span>
                </div>
              </div>
              <div className="otp-container">
                {/* <div className="otp-resend-text">
                  {otp_text.otp_subheader_text1}<button onClick={() => console.log('Resend OTP')}>{otp_text.otp_resend}</button>
                </div> */}
                <div
                  className={otpNumberClass}
                  onFocus={otpFocus}
                  onBlur={otpBlur}
                >
                  <OtpInput
                    value={phoneOTP.otp}
                    // value={phoneOTPHidden.otp}
                    onChange={otpHandler}
                    numInputs={4}
                    isInputNum={true}
                    placeholder="0"
                    shouldAutoFocus={true}
                    // shouldAutoFocus
                  />
                  <div className="grey-dots-container">
                    {greyDotArr.map((item) =>
                      item ? (
                        <img src={greyDot} alt="" style={{ width: '8px' }} />
                      ) : (
                        <div style={{ width: '8px' }}></div>
                      ),
                    )}
                  </div>
                </div>
              </div>
              {/* {otpTimer === 0 && <p className="otp-expired">OTP expired.</p>}
              {otpTimer > 0 && <p className="otp-timer">OTP expires in {otpTimerString}</p>} */}
              <div className="flex-the-toast">
                <div style={{ display: showToast }} className="custom-toast">
                  {toastMessage}
                </div>
              </div>
              {loader ? (
                <button
                  className={`nextBtn-np ${iOSbtnNormal}`}
                  onClick={otpNextButtonClick}
                  disabled={otpValidation ? false : true}
                >
                  <div className="loader-container-np">
                    <LoaderLight
                      loaderData={loaderData}
                      loaderStyle="loader-light-np"
                    />
                  </div>{' '}
                </button>
              ) : (
                <form onSubmit={otpNextButtonClick}>
                  <button
                    type="submit"
                    className={
                      otpValidation
                        ? `nextBtn-np-enabled ${iOSbtnEnabled}`
                        : `nextBtn-np ${iOSbtnNormal}`
                    }
                    // onClick={otpNextButtonClick}
                    disabled={otpValidation ? false : true}
                  >
                    {nextText}
                  </button>
                </form>
              )}
            </div>
          </div>

          {/* {loader && (
            <div className={'loader-container'} onClick={onClick}>
              <LoaderLight loaderStyle="loader-btr" loaderData={loaderData} />
            </div>
          )} */}
        </div>
      </div>
      {/* </Modal> */}
    </>
  );
};

export default OTP;
